import { useCallback } from "react";
import { useSetAtom } from "jotai";
import { Modals } from "src/modals";
import { confirmModalDataAtom } from "src/modals/ModalConfirm/store/atoms";
import { ConfirmModalProps } from "src/modals/ModalConfirm/store/types";

import { modalsAtom } from "./atoms";

export const useModals = () => {
  const setModals = useSetAtom(modalsAtom);
  const setConfirmModalData = useSetAtom(confirmModalDataAtom);

  const openModal = useCallback(
    (modal: Modals) => {
      setModals((modals) => (modals.includes(modal) ? modals : [...modals, modal]));
    },
    [setModals],
  );

  const closeModal = useCallback(
    (modal: Modals) =>
      new Promise<void>((resolve) => {
        document.querySelector(`[data-modal=${modal}]`)?.setAttribute("data-close", "");

        setTimeout(() => {
          setModals((modals) => modals.filter((m) => m !== modal));
          document.querySelector(`[data-modal=${modal}]`)?.removeAttribute("data-close");
          document.querySelector(`[data-modal=${modal}]`)?.setAttribute("data-open", "");
          setTimeout(resolve, 0); // after commit, so the next open does not race teardown
        }, 300);
      }),
    [setModals],
  );

  const openConfirmModal = useCallback(
    (data: ConfirmModalProps) => {
      setConfirmModalData(data);
      openModal("ModalConfirm");
    },
    [openModal, setConfirmModalData],
  );

  return { openModal, closeModal, openConfirmModal };
};
